import React from 'react';
import PropTypes from 'prop-types';

import FormManager from 'src/core/gd-form/common/form-manager';
import Form from 'src/core/gd-form/form/form-modal-new/form-modal-new.tsx';
import FormError from 'src/core/gd-form/common/form-error/form-error.tsx';
import CustomFieldFormElement from 'core/gd-form/form-element/custom-field/custom-field-form-element.jsx';

class ModalActionCustomField extends React.Component {
    static propTypes = {
        onSubmit: PropTypes.func.isRequired,
        customFieldId: PropTypes.string.isRequired,
    };

    UNSAFE_componentWillMount() {
        this.customField = gd.session.customFields.get(this.props.customFieldId);

        const initFormData = {
            value: this.customField.defaultValue
        };

        const formStructure = {
            fields: {
                value: {
                    type: 'input',
                    label: this.customField.name
                },
            },
            onSubmit: this.onSubmit
        };

        this.form = new FormManager(formStructure,initFormData);
    }

    onSubmit = (result) => {
        this.props.onSubmit(result);
    };

    render() {
        const { params } = this.customField;
        // const labelClasses = Classes("label", "custom-field-"+this.customField.typeName);
        // const labelIconClasses = Classes("cf-icon", this.customField.icon);
        // <div className={labelIconClasses}> </div>

        return (
            <Form form={this.form} submitLabel="Submit" >

                <div className="tbl">
                    <div className="row">
                        <div className="label">
                            {this.customField.name}
                        </div>
                        <div className="element">
                            <CustomFieldFormElement form={this.form} name="value" customFieldId={this.customField.id} params={params ? params : {}}/>
                            <FormError form={this.form} name="value" />
                        </div>


                    </div>
                </div>


            </Form>
        );
    }
}

module.exports = ModalActionCustomField;